import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src';
import { JiraContextContainer } from '@atlassian/jira-context-container';
import { FeedbackCollectorRenderer } from '@atlassian/jira-feedback-collector';
import { mobileConfiguration } from '@atlassian/jira-issue-view-configurations';
import IssueApp from '@atlassian/jira-issue-view/src/views/issue-details/issue-app';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { StrictMode } from '@atlassian/jira-react-strict-mode';

import { getIssueKey } from './util';

const fragmentDiv = document.getElementById('mobile-issue');
if (fragmentDiv === null) {
	throw new Error('mobile-issue element not found');
}
const getContainer = () => document.getElementById('mobile-issue-container');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	padding: '10px 0',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: colors.N0,
});

const MobileIssueApp = AnalyticsSource('mobileIssue', SCREEN)(IssueApp);

fragmentDiv.addEventListener('show-mobile-issue', () => {
	const container = getContainer();

	const configWithAppKey = mobileConfiguration();
	const { applicationKey, ...configWithoutAppKey } = configWithAppKey;
	if (container) {
		render(
			<StrictMode>
				<Wrapper>
					<JiraContextContainer>
						<MobileIssueApp
							{...configWithoutAppKey}
							analyticsSource="mobile-issue"
							shouldSetInitialFocus
							issueKey={getIssueKey(window.location.href)}
						/>
						<FeedbackCollectorRenderer />
					</JiraContextContainer>
				</Wrapper>
			</StrictMode>,
			container,
		);
	}
});

fragmentDiv.addEventListener('hide-mobile-issue', () => {
	setTimeout(() => {
		// @ts-expect-error - TS2345 - Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Element | DocumentFragment'.
		unmountComponentAtNode(getContainer());
	});
});
